import dayjs from 'dayjs'

export function buildTitleForAPrescriptionTemplate({
  clincLocationData,
  clinicBrandData,
  prescriptionTemplate,
  mentorProfileData,
  idx,
}) {
  console.log({ clincLocationData, clinicBrandData, prescriptionTemplate, mentorProfileData, idx })
  if (prescriptionTemplate?.title) {
    return prescriptionTemplate?.title
  }
  const timeString = dayjs(prescriptionTemplate?.modifiedTime).format('DD-MM-YYYY')

  return `${
    clinicBrandData?.brandName || clinicBrandData?.clinicBrandName || clinicBrandData?.title || ''
  } ${clincLocationData?.title || ''} - ${prescriptionTemplate?.layout || ''} - ${
    mentorProfileData?.name || ''
  } - ${timeString}`
}
